export const SET_STAGE = 'SET_STAGE';
export const FIELD_COMPLETED = 'FIELD_COMPLETED';
export const FIELD_IN_EDIT = 'FIELD_IN_EDIT';
export const UPDATE_BOOK_FIELD = 'UPDATE_BOOK_FIELD';
export const UPDATE_BOOK_FIELDS = 'UPDATE_BOOK_FIELDS';
export const CLEAR_BOOK_FIELDS = 'CLEAR_BOOK_FIELDS';

export const VALIDATE_BOOK_INPUTS_START = 'VALIDATE_BOOK_INPUTS_START';
export const VALIDATE_BOOK_INPUTS_SUCCESS = 'VALIDATE_BOOK_INPUTS_SUCCESS';
export const VALIDATE_BOOK_INPUTS_ERROR = 'VALIDATE_BOOK_INPUTS_ERROR';

export const SUBMIT_DATA_START = 'SUBMIT_DATA_START';
export const SUBMIT_DATA_SUCCESS = 'SUBMIT_DATA_SUCCESS';
export const SUBMIT_DATA_ERROR = 'SUBMIT_DATA_ERROR';

export const GET_BOOK_INPUT_DATA_SUCCESS = 'GET_BOOK_INPUT_DATA_SUCCESS';
